<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file StreetSign.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  StreetSign.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: StreetSign 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-01-04
 Time: 13:12
------------------------------------------------------------------------------->
<template>
    <div class="entity--sign mx-1">
        <span class="d-block m0 p-1 lh-10 fs-10 text-dark z-depth-1">
        <slot name="content" data-test>
        </slot>
        </span>
    </div>
</template>

<script>
	export default {
		name: "street-sign",
		components: {},
		props: {},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				cls:{

                }
            }
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/StreetSign.vue